// extracted by mini-css-extract-plugin
module.exports = {"card":"ServiceCard_card__FEvLM","icon":"ServiceCard_icon__8tmdG","title":"ServiceCard_title__RWj5l","description":"ServiceCard_description__9maFl"};